import React from 'react';

const AppSupport = () => (
  <div>
    <br /><br />
    <h2>PD Fiber CommandIQ Support</h2>
    <p><b>For support regarding the PD Fiber CommandIQ app, please contact us:</b></p>
    <p><i><a href="mailto:development@pdec.coop">development@pdec.coop</a></i></p>
  </div>
);

export default AppSupport;


// WEBPACK FOOTER //
// ./src/components/sections/documents/app-support.js